import { DragEvent, FC } from 'react';
import cx from 'classnames/bind';

import { Cursor } from '@/components/Cursor';
import DeleteButton from '../DeleteButton/DeleteButton';

import styles from './SelectedAnswer.module.scss';

interface SelectedAnswerProps {
  state: number;
  selectedAnswer: string[];
  deleteMessage: (value: string) => void;
  onDrop: (e: DragEvent<HTMLDivElement>) => void;
  isMultiple?: boolean;
  type?: 'game' | 'training';
  className?: string;
}

const cn = cx.bind(styles);

const SelectedAnswer: FC<SelectedAnswerProps> = ({
  state,
  selectedAnswer,
  deleteMessage,
  onDrop,
  isMultiple = false,
  type = 'game',
  className,
}) => {
  const dragOverHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return isMultiple ? (
    <div
      className={cn('answer', className)}
      onDragOver={(e) => dragOverHandler(e)}
      onDrop={onDrop}
    >
      {selectedAnswer.length > 0
        ? selectedAnswer.map((item) => (
            <div key={item} className={cn('answer-item')}>
              {item}
              <DeleteButton
                className={cn('delete-button-mini')}
                deleteMessage={() => deleteMessage(item)}
              />
            </div>
          ))
        : 'Перетащите выбранный вариант ответа в это поле'}
    </div>
  ) : (
    <div
      className={cn(
        className,
        selectedAnswer.length ? 'answer-selected' : 'answer',
      )}
      onDragOver={(e) => dragOverHandler(e)}
      onDrop={onDrop}
    >
      {selectedAnswer[0] || 'Перетащите выбранный вариант ответа в это поле'}
      {selectedAnswer.length > 0 && (
        <DeleteButton
          className={cn('delete-button')}
          deleteMessage={() => deleteMessage(selectedAnswer[0])}
        />
      )}
      {selectedAnswer.length > 0 && state === 1 && type === 'training' && (
        <Cursor className={cn('cursor')} />
      )}
    </div>
  );
};

export default SelectedAnswer;
